<template>
    <div class="container">
        <div class="handle-box-search">
            <div class="handle-box">
                <el-row class="head-search">
                    <el-col :span="8">
                        <span class="title">姓名:</span>
                        <!-- 搜索姓名 -->
                        <el-input
                            v-model="search_data.name"
                            placeholder="请输入姓名"
                            class="handle-input mr10"
                            @keyup.enter.native="getDriverServerFee"
                        ></el-input>
                    </el-col>
                    <el-col :span="8">
                        <span class="title">司机手机号:</span>
                        <!-- 搜索商家手机号 -->
                        <el-input
                            v-model="search_data.phone"
                            placeholder="请输入司机手机号"
                            class="handle-input mr10"
                            @keyup.enter.native="getDriverServerFee"
                        ></el-input>
                    </el-col>
                    
                </el-row>

            </div>

            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            <el-button type="primary" icon="el-icon-search" @click="getDriverServerFee">搜索</el-button>

           
        </div>
         <!-- 表格 -->
            <el-table
                :data="tableData"
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
            >
                

                <el-table-column prop="city.name" label="城市名称"> </el-table-column>
                <el-table-column prop="driver.name" label="姓名"> </el-table-column>
                <el-table-column prop="driver.phone" label="电话"> </el-table-column>

                <el-table-column prop="amount" label="总金额"> </el-table-column>
                <el-table-column prop="total_money" label="剩余金额"> </el-table-column>
                <el-table-column prop="used_amount" label="已使用金额"> </el-table-column>



                <el-table-column prop="time.YmdHis" label="创建时间">
                    
                </el-table-column>
            </el-table>

            <!-- 分页组件 -->
            <div class="pagination">
                <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
            </div>

        
    </div>
</template>
  
  <script>
var _this;

export default {
    components: {},
    data() {
        return {
            // 存放表格数据
            tableData: [],

            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                name: '',
                phone: ''
            },

            result_data: [],

            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.getDriverServerFee();
    },

    methods: {
        getDriverServerFee() {
            _this.search_data.page = 1;

            _this.serviceFeeLists();
        },

        //搜索公司列表
        serviceFeeLists() {
            console.log(_this.search_data);
            _this
                .$post('/service_fee/getDriverServerFee', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.result_data = res;
                    _this.tableData = res.data;
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.serviceFeeLists();
        },
        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>
  
<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
.container {
    height: 100%;
}
</style>